import { Box, Flex } from '@chakra-ui/react';
import { Skeleton } from '@/components/ui/skeleton';

/**
 * Loading placeholder for a note, shaped like NoteCard: the same babyPowder card
 * with an avatar dot + author/date row, then two body lines. Mirrors the real
 * card so the NOTES section loads into its own silhouette rather than a spinner.
 */
const NoteCardSkeleton: React.FC = () => {
  return (
    <Box
      borderWidth="1px"
      borderColor="border.DEFAULT"
      rounded="lg"
      bg="babyPowder"
      px="11px"
      py="10px"
    >
      <Flex align="center" gap="7px" mb="8px">
        <Skeleton height="21px" width="21px" rounded="full" flexShrink={0} />
        <Skeleton height="11px" width="72px" />
        <Skeleton height="10px" width="38px" ml="auto" />
      </Flex>
      <Skeleton height="10px" width="100%" mb="5px" />
      <Skeleton height="10px" width="70%" />
    </Box>
  );
};

export default NoteCardSkeleton;
